module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contenttoc#ta",
      "id": "ca"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("David and Donna’s story is one of the tragic possibilities that life affords us. We must exercise our abilities to their fullest extent to make the best of our most challenging trials. This is exemplified not only by Donna’s family trauma, but also by their progressive and heartfelt triumph. Donna’s narrative explains traumatic brain injury and its multiple destructive tentacles, while showing us the power of love, dedication, and persistence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I admire and respect David and Donna’s battle to overcome what so many of us cannot imagine. They have reintroduced us to the meaning of our existence and to the sanctity of its preservation.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This account has reinforced my dedication to my profession. Medicine for me has always been a unique privilege to heal and comfort. A physician’s knowledge and training must provide thorough and evidence-based competence, but always with compassion and professionalism. Every day, I am reminded of my oath to serve as a healer by being a trusted liaison between formidable illness and human beings.")]), _vm._v(" "), _c('p', {
    staticClass: "tx13"
  }, [_vm._v("David and Donna have my admiration, and I thank them for allowing me to assist in their quest to overcome incredible adversity.")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#ta"
    }
  }, [_vm._v("Michael Kailas, MD")])]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("Neurologist")]), _vm._v(" "), _c('p', {
    staticClass: "txr"
  }, [_vm._v("New Jersey")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a65bbfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter02.vue
// module id = 72
// module chunks = 0